import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { sidebarStatePropType } from 'components/Sidebar/propTypes';
import OptionSelect from 'components/OptionSelect';
import { useQuestionnaireData } from '../context';
import QuestionTitle from './QuestionTitle';
import QuestionSubTitle from './QuestionSubTitle';
import QuestionOptionsContainer from './QuestionOptionsContainer';

const SingleOptionSelect = ({
  value,
  onChange,
  question,
  sidebarState,
  handleNextButtonClick,
}) => {
  const { form } = useSelector((state) => ({
    form: state.questionnaire.form,
  }));
  const { embedded } = useQuestionnaireData();

  const {
    id,
    title,
    subtitle,
    options,
    disableNextOnOptionSelect,
  } = question;

  const handleOptionSelectChange = (changedOptions) => {
    const option = Array.isArray(changedOptions) ? changedOptions[0] : changedOptions;
    const isNeedToUnselect = !!value && value?.value === option?.value;

    onChange(isNeedToUnselect ? null : option);

    if (!disableNextOnOptionSelect && !isNeedToUnselect) {
      setTimeout(() => {
        handleNextButtonClick();
      }, 200);
    }
  };

  return (
    <Grid key={id}>
      <QuestionTitle label={title} />

      {subtitle && <QuestionSubTitle label={subtitle} />}

      <QuestionOptionsContainer maxHeight={sidebarState ? 'calc(100vh - 250px)' : null}>
        <OptionSelect
          options={options}
          form={form}
          onChange={handleOptionSelectChange}
          values={value ?? []}
          small={embedded}
        />
      </QuestionOptionsContainer>
    </Grid>
  );
};

SingleOptionSelect.propTypes = {
  /**
   * Question object with title, subtitles, etc
   */
  question: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  handleNextButtonClick: PropTypes.func.isRequired,
  value: PropTypes.any,
  sidebarState: sidebarStatePropType,
};

export default SingleOptionSelect;
